import { render, staticRenderFns } from "./points-calculator.vue?vue&type=template&id=79ee38f2&scoped=true&lang=pug"
import script from "./points-calculator.vue?vue&type=script&lang=js"
export * from "./points-calculator.vue?vue&type=script&lang=js"
import style0 from "./points-calculator.vue?vue&type=style&index=0&id=79ee38f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee38f2",
  null
  
)

export default component.exports